var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7883 8.98313C11.0954 8.87475 11.207 9.01309 11.0387 9.29032L8.30566 13.7918C8.13685 14.0698 7.86267 14.069 7.69435 13.7918L4.96133 9.29032C4.79252 9.01228 4.90431 8.87465 5.21168 8.98313L7.81543 9.9021C7.91737 9.93808 8.08267 9.93806 8.18457 9.9021L10.7883 8.98313Z",
    fill: "rgba(0, 0, 0, 0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96133 6.70967C4.79301 6.9869 4.9046 7.12524 5.21167 7.01686L7.81543 6.09789C7.91733 6.06193 8.08263 6.06191 8.18457 6.09789L10.7883 7.01686C11.0957 7.12535 11.2075 6.98771 11.0387 6.70967L8.30565 2.20822C8.13734 1.931 7.86316 1.93019 7.69435 2.20822L4.96133 6.70967Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort_asc.ce668f35ec2050c245b3c9f8c16445aa.svg";
export { ForwardRef as ReactComponent };